var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"portal"},[_c('PortalLinks',{attrs:{"items":_vm.servicos}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }